
class SliderInput {

    constructor($compile) {

        this.$compile = $compile;

        return {
            restrict: 'E',
            templateUrl: 'forms/slider-input.html',
            compile: function (Elem, Attrs) {
                var keysToCopy = [
                  'ngModel',
                  'type',
                  'placeholder',
                  'name',
                  'label',
                  'pattern',
                  'required',
                  'minlength',
                  'maxlength',
                  'min',
                  'max',
                  'readonly',
                  'value',
                  'step'
                ];
                var $label = Elem.find('label');

                // copy attrs to the slider
                Object.keys(Attrs).forEach(
                    function (key) {
                      if (key.indexOf('ng') === 0 || keysToCopy.indexOf(key) > -1) {
                        
                        Elem.find('slider').attr(_.kebabCase(key), Attrs[key] || 1);
                      }
                    }
                );

                //add label and id
                if (Attrs['label']) $label.text(Attrs['label']);
                if (Attrs['name']) $label.attr('for', Attrs['name']);

            }
        };

    }

}


angular.module('cpm')
    .directive('sliderInput', () => {
        'use strict';
        return new SliderInput();
    });
